import Alpine from 'alpinejs'
import autopayAchForm from './alpine/autopayAchForm'
import autopayCardForm from './alpine/autopayCardForm'
import autopaySurcharge from './alpine/autopaySurcharge'
import basicForm from './alpine/basicForm'
import paymentAchForm from './alpine/paymentAchForm'
import paymentCardForm from './alpine/paymentCardForm'
import privacyConsent from './alpine/privacyConsent'
import datePicker from './alpine/datePicker'
import focus from '@alpinejs/focus'
import posthogSurveyTrigger from './alpine/posthogSurveyTrigger'
import ownerplusDatePickerCell from './alpine/ownerplusDatePickerCell'
import tooltipSimple from './alpine/tooltipSimple'
import ownerplusConvertPay from './alpine/ownerplusConvertPay'
import paymentSurcharge from './alpine/paymentSurcharge'
import menuCombobox from './alpine/components/menu/combobox'
import menuSelect from './alpine/components/menu/select'
import tablistNav from './alpine/components/tabs/tablistNav'
import mortgageManager from './alpine/mortgageManager'
import noticeStack, { noticeStore } from './alpine/noticeStack'
import '~/owners.css'

window.Alpine = Alpine

Alpine.plugin(focus)
Alpine.data('autopayAchForm', autopayAchForm)
Alpine.data('autopayCardForm', autopayCardForm)
Alpine.data('autopaySurcharge', autopaySurcharge)
Alpine.data('basicForm', basicForm)
Alpine.data('datePicker', datePicker)
Alpine.data('menuCombobox', menuCombobox)
Alpine.data('menuSelect', menuSelect)
Alpine.data('mortgageManager', mortgageManager)
Alpine.data('noticeStack', noticeStack)
Alpine.data('ownerplusConvertPay', ownerplusConvertPay)
Alpine.data('ownerplusDatePickerCell', ownerplusDatePickerCell)
Alpine.data('paymentAchForm', paymentAchForm)
Alpine.data('paymentCardForm', paymentCardForm)
Alpine.data('paymentSurcharge', paymentSurcharge)
Alpine.data('posthogSurveyTrigger', posthogSurveyTrigger)
Alpine.data('privacyConsent', privacyConsent)
Alpine.data('tablistNav', tablistNav)
Alpine.data('tooltipSimple', tooltipSimple)
Alpine.store('notices', noticeStore)
Alpine.start()
